import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Button, Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const publishPanelSpacingBottom = css`
    margin: ${Spacing.LG}px 0;
`;

export const DestinationDetails = styled.div`
    display: flex;
    flex-direction: column;

    h2 {
        margin-bottom: 0;
    }
`;

export const DestinationTitle = styled.h2`
    ${Fonts.Heading.H400}
`;

export const DestinationSubTitle = styled.h3`
    ${Fonts.Heading.H600}
    color: ${Colors.Gray.V300};
`;

export const ButtonWithSpacing = styled(Button)`
    margin-right: ${Spacing.MD}px;
`;

export const PanelDetailsContainer = styled.div`
    display: flex;
    flex-grow: 1;
    gap: ${Spacing.MD}px;
    align-items: center;
`;

export const LensForUpdateContainer = styled.div`
    display: flex;
    gap: ${Spacing.LG}px;
    justify-content: space-between;
`;

export const LensForUpdateDetails = styled.div`
    display: flex;
`;

export const PanelCtaContainer = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
`;
